'use client';
import { useState } from 'react';
import { Input } from '~/components';
import { useRegion } from '~/region/hooks';
import { cmToFeetInches, feetInchesToCm } from '~/utils';

export const FormHeight = ({
  label,
  height,
  setHeight,
}: {
  label?: string;
  height: number;
  setHeight: (height: number) => void;
}) => {
  const { isUs } = useRegion();
  const [feet, setFeet] = useState(cmToFeetInches(height).feet);
  const [inches, setInches] = useState(cmToFeetInches(height).inches);

  return (
    <div className="space-y-4">
      <div>{label || 'Height'}</div>

      {isUs ? (
        <div className="flex gap-5">
          <div className="flex items-center gap-4">
            <Input
              className="w-24"
              type="number"
              value={feet}
              min={0}
              onChange={(event) => {
                const newFeet = Number(event.target.value);

                setFeet(newFeet);
                setHeight(feetInchesToCm({ feet: newFeet, inches }));
              }}
            />

            <div className="font-semibold">FT</div>
          </div>

          <div className="flex items-center gap-4">
            <Input
              className="w-24"
              type="number"
              value={inches}
              min={0}
              onChange={(event) => {
                const newInches = Number(event.target.value);

                setInches(newInches);
                setHeight(feetInchesToCm({ feet, inches: newInches }));
              }}
            />

            <div className="font-semibold">IN</div>
          </div>
        </div>
      ) : (
        <div className="flex items-center gap-4">
          <Input
            className="w-40"
            type="number"
            value={height}
            onChange={(event) => setHeight(Number(event.target.value))}
            step={0.1}
            min={0}
            max={300}
          />

          <div className="font-semibold">CM</div>
        </div>
      )}
    </div>
  );
};
